import { Component, EventEmitter, Output, OnInit } from '@angular/core';
import {
  Cabecera,
  CentrosConsumoUsuarioToken,
  DataSelectRFCEmisorReporteador,
  Emisores,
  EmisoresForm,
  Select2Option,
  Select2UpdateEvent,
  SucursalesCentrosConsumoPorRfc,
  dataUser,
  listSeries,
} from '../../../../shared/models';
import { FormControl, FormGroup } from '@angular/forms';
import { Validators } from '@angular/forms';
import { FacturacionService } from '../../../../shared/services/facturacion.service';

@Component({
  selector: 'app-form-emisor',
  standalone: false,
  templateUrl: './form-emisor.component.html',
  styleUrl: './form-emisor.component.scss',
})
export class FormEmisorComponent{
  // public isCollapsed: boolean = false;
  // @Output() public send_data_emisor: EventEmitter<EmisoresForm> = new EventEmitter<EmisoresForm>();
  // @Output() public send_validation_emisor: EventEmitter<boolean> = new EventEmitter<boolean>();
  // public formEmisor: FormGroup;

  // // Banderas para el html
  // public isloading: boolean = false;
  // public isRfcLoaded: boolean = false;
  // public isCentroConsumoEnabled: boolean = false;
  // public isCentroConsumoSelected: boolean = false;
  // public isCCloaded: boolean = false;

  // // Inicialización de objetos de acuerdo a interfaces
  // public emisores: Emisores = { rfcs: [] };
  // public sucursalesYCentros: SucursalesCentrosConsumoPorRfc = { rfc: [] };
  // public sucursalSeleccionada: string = '';
  // public centroConsumoSeleccionado: string = '';
  // public sucursales: string[] = [];
  // public centrosConsumo: string[] = [];
  // public centrosConsumoFiltrados: string[] = [];
  // public dataUser: dataUser;
  // public dataUserStorage: any = sessionStorage.getItem("dataUser"); 
  // public dataRFCEmisor!: Array<DataSelectRFCEmisorReporteador>;
  // public catalogoRFCEmisor: Select2Option[] = []; 
  // public dataSucursales!: CentrosConsumoUsuarioToken[];
  // public catalogosSucursales: Select2Option[] = [];
  // public eventValue: any[] = [];
  // public dataCentroConsumo!: CentrosConsumoUsuarioToken[];
  // public catalogosCentrosConsumos: Select2Option[] = [];
  // public eventValueCC: any[] = [];
  // public centroConsumo: number | null = null;

  // public cabeceraTemporal!: Cabecera;
  // public eventCC: any[] = []
  // public listSeries!: listSeries;
  // public catalogosSeries: Select2Option[] = [];

  // constructor(private  facturacionService: FacturacionService) {
  //   this.dataUser = JSON.parse(this.dataUserStorage)
  //   let listaRFCEmisor: Array<DataSelectRFCEmisorReporteador> = [];
  //   this.dataUser.centros_consumo.forEach(elem => {
  //     listaRFCEmisor.push(
  //       {
  //         id_emisor: elem.id_emisor,
  //         rfc_emisor: elem.rfc_emisor
  //       }
  //     );
  //   });
  //   this.dataRFCEmisor = this.objetosUnicosRFCEmisor(listaRFCEmisor);
  //   this.dataRFCEmisor.forEach(elem => {
  //     this.catalogoRFCEmisor.push({
  //       label: elem.rfc_emisor, 
  //       value: elem.id_emisor
  //     })
  //       });

  //   this.formEmisor = new FormGroup({
  //     rfc: new FormControl('', Validators.required),
  //     facAtrAdquirente: new FormControl(),
  //     regimenFiscal: new FormControl('', Validators.required),
  //     nombre: new FormControl('', Validators.required),
  //     codigoPostal: new FormControl('', Validators.required),
  //     identificadorSucursalId: new FormControl(null, Validators.required),
  //     centroConsumoId: new FormControl(null, Validators.required),
  //     serie: new FormControl(null)
  //   });
  //   this.facturacionService.eventSendCabecera.subscribe(
  //     response =>{
  //       this.cabeceraTemporal = response;
  //     }
  //   );
  // }
  
  // public buscarDatosPorRfc(event: Select2UpdateEvent): void {
  //   this.isRfcLoaded = false;
  //   while(this.eventValue.length){
  //     this.eventValue.pop()
  //   }

  //   while(this.catalogosSucursales.length){
  //     this.catalogosSucursales.pop()
  //   }
    
  //   this.eventValue.push(event.options[0].value)
  //   const resultado: CentrosConsumoUsuarioToken[] = this.dataUser.centros_consumo.filter(item => this.eventValue.includes(item.id_emisor));
  //   const resultadoFinal: CentrosConsumoUsuarioToken[] = resultado.filter((item, index, arr) => {
  //     return arr.findIndex(obj => obj.id_sucursal === item.id_sucursal) === index;
  //   });
  //   this.dataSucursales = resultadoFinal;
  //   this.formEmisor.controls["nombre"].setValue(resultadoFinal[0].nombre_emisor);
  //   this.dataSucursales.forEach(elem => {
  //     this.catalogosSucursales.push({
  //       label: elem.nombre_sucursal, 
  //       value: elem.id_sucursal
  //     })
  //   });

  //   this.formEmisor.controls["rfc"].setValue(event.options[0].label)
  //   this.facturacionService.emisionIntegracion(this.formEmisor.value["rfc"]).subscribe(
  //     response => {
  //       this.formEmisor.controls['regimenFiscal'].setValue(response.centros_consumo[0].regimen_fiscal);
  //       this.formEmisor.controls['codigoPostal'].setValue(response.centros_consumo[0].cp);
  //       this.formEmisor.controls["identificadorSucursalId"].reset();
  //       this.formEmisor.controls["centroConsumoId"].reset();
  //       this.formEmisor.controls["serie"].reset();
  //       this.sendDataEmisor();
  //       this.isRfcLoaded = true;
  //     }
  //   );
   
  // }

  // public sendDataEmisor(): void {    
  //   this.send_data_emisor.emit(this.formEmisor.value);
  //   this.send_validation_emisor.emit(this.formEmisor.valid);
  // }

  // public patterNumber(event: any): void {
  //   let value = event.target.value
  //     .replace(/[^0-9.]/g, '')
  //     .replace(/(\..*)\./g, '$1');
  //   this.formEmisor.controls['codigoPostal'].setValue(value);
  //   this.sendDataEmisor();
  // }

  // public objetosUnicosRFCEmisor(array: Array<DataSelectRFCEmisorReporteador>): Array<DataSelectRFCEmisorReporteador> {
  //   const resultado = [];
  //   const objetosVistos = new Set();
 
  //   for (const obj of array) {
  //     const claveUnica = JSON.stringify(obj);
  //     if (!objetosVistos.has(claveUnica)) {
  //       objetosVistos.add(claveUnica);
  //       resultado.push(obj);
  //     }
  //   }
  //   return resultado;
  // }

  // public buscarCCporSucursal(event: Select2UpdateEvent): void {

  //   while(this.eventValueCC.length){
  //     this.eventValueCC.pop()
  //   }

  //   while(this.catalogosCentrosConsumos.length){
  //     this.catalogosCentrosConsumos.pop()
  //   }

  //   this.eventValueCC.push(event.options[0].value)
  //   const resultado: CentrosConsumoUsuarioToken[] = this.dataUser.centros_consumo.filter(item => this.eventValueCC.includes(item.id_sucursal));
  //   const resultadoFinal = resultado.filter(item => this.eventValue.includes(item.id_emisor));
  //   this.dataCentroConsumo = resultadoFinal;
  //   this.dataCentroConsumo.forEach(elem => {
  //     this.catalogosCentrosConsumos.push({
  //       label: elem.nombre_centro_consumo, 
  //       value: elem.id_centro_consumo
  //     })
  //   });
    
  //   this.isCentroConsumoEnabled = true;
  //   this.formEmisor.controls["centroConsumoId"].reset();
  //   this.formEmisor.controls["serie"].reset();
  //   this.sendDataEmisor();
  // }
  // public buscarSeriePorCC(event: Select2UpdateEvent){
  //   while(this.eventCC.length){
  //     this.eventCC.pop();
  //   }

  //   while(this.catalogosSeries.length){
  //     this.catalogosSeries.pop()
  //   }

  //   this.eventCC.push(event.options[0].value)
  //   this.facturacionService.emisionSeries(this.eventCC[0], this.cabeceraTemporal.tipoCfdi).subscribe(
  //     response => {
  //       this.listSeries = response

  //       this.listSeries.series.forEach(elem => {
  //         this.catalogosSeries.push({
  //           label: elem.SERIE, 
  //           value: elem.SERIE
  //         })
  //       });
  //       this.sendDataEmisor();
  //       this.isCCloaded = true;
  //     }
  //   ); 
  // }
}
